export default __webpack_public_path__ + "static/media/contactOther.6ce69634.svg";